<div (click)="onClick()" class="d-flex flex-column justify-content-between">
    <video autoplay class="video" id="screensaver" loop muted>
        <source src="assets/video/attract-loop.webm" type="video/webm">
        <source src="assets/video/attract-loop.mp4" type="video/mp4">
    </video>
</div>
